import AcquiringActionTypes from './acquiring-types'

export const startGetDefaultCardAcquiring = data => ({
    type: AcquiringActionTypes.START_GET_DEFAULT_CARD_ACQUIRING,
    payload: data,
})

export const successGetDefaultCardAcquiring = data => ({
    type: AcquiringActionTypes.SUCCESS_GET_DEFAULT_CARD_ACQUIRING,
    payload: data,
})

export const failureGetDefaultCardAcquiring = data => ({
    type: AcquiringActionTypes.FAILURE_GET_DEFAULT_CARD_ACQUIRING,
    payload: data,
})

export const finishGetDefaultCardAcquiring = data => ({
    type: AcquiringActionTypes.FINISH_GET_DEFAULT_CARD_ACQUIRING,
    payload: data,
})

export const startGetAccountsAcquiring = data => ({
    type: AcquiringActionTypes.START_GET_ACCOUNTS_ACQUIRING,
    payload: data,
})

export const successGetAccountsAcquiring = data => ({
    type: AcquiringActionTypes.SUCCESS_GET_ACCOUNTS_ACQUIRING,
    payload: data,
})

export const failureGetAccountsAcquiring = data => ({
    type: AcquiringActionTypes.FAILURE_GET_ACCOUNTS_ACQUIRING,
    payload: data,
})

export const finishGetAccountsAcquiring = data => ({
    type: AcquiringActionTypes.FINISH_GET_ACCOUNTS_ACQUIRING,
    payload: data,
})

export const startAcquiringTransfersDownload = data => ({
    type: AcquiringActionTypes.START_ACQUIRING_TRANSFERS_DOWNLOAD,
    payload: data,
})

export const successAcquiringTransfersDownload = data => ({
    type: AcquiringActionTypes.SUCCESS_ACQUIRING_TRANSFERS_DOWNLOAD,
    payload: data,
})

export const failureAcquiringTransfersDownload = data => ({
    type: AcquiringActionTypes.FAILURE_ACQUIRING_TRANSFERS_DOWNLOAD,
    payload: data,
})

export const finishAcquiringTransfersDownload = data => ({
    type: AcquiringActionTypes.FINISH_ACQUIRING_TRANSFERS_DOWNLOAD,
    payload: data,
})

export const startCardAcquiringMerchants = data => ({
    type: AcquiringActionTypes.START_CARD_ACQUIRING_MERCHANTS,
    payload: data,
})

export const successCardAcquiringMerchants = data => ({
    type: AcquiringActionTypes.SUCCESS_CARD_ACQUIRING_MERCHANTS,
    payload: data,
})

export const failureCardAcquiringMerchants = data => ({
    type: AcquiringActionTypes.FAILURE_CARD_ACQUIRING_MERCHANTS,
    payload: data,
})

export const finishCardAcquiringMerchants = data => ({
    type: AcquiringActionTypes.FINISH_CARD_ACQUIRING_MERCHANTS,
    payload: data,
})

export const startGetCardAcquiringSettlements = data => ({
    type: AcquiringActionTypes.START_GET_CARD_ACQUIRING_SETTLEMENTS,
    payload: data,
})

export const successGetCardAcquiringSettlements = data => ({
    type: AcquiringActionTypes.SUCCESS_GET_CARD_ACQUIRING_SETTLEMENTS,
    payload: data,
})

export const failureGetCardAcquiringSettlements = data => ({
    type: AcquiringActionTypes.FAILURE_GET_CARD_ACQUIRING_SETTLEMENTS,
    payload: data,
})

export const finishGetCardAcquiringSettlements = data => ({
    type: AcquiringActionTypes.FINISH_GET_CARD_ACQUIRING_SETTLEMENTS,
    payload: data,
})

export const startGetCardAcquiringCharges = data => ({
    type: AcquiringActionTypes.START_GET_CARD_ACQUIRING_CHARGES,
    payload: data,
})

export const successGetCardAcquiringCharges = data => ({
    type: AcquiringActionTypes.SUCCESS_GET_CARD_ACQUIRING_CHARGES,
    payload: data,
})

export const failureGetCardAcquiringCharges = data => ({
    type: AcquiringActionTypes.FAILURE_GET_CARD_ACQUIRING_CHARGES,
    payload: data,
})

export const finishGetCardAcquiringCharges = data => ({
    type: AcquiringActionTypes.FINISH_GET_CARD_ACQUIRING_CHARGES,
    payload: data,
})

export const startAcquiringCredentialsRegenerate = data => ({
    type: AcquiringActionTypes.START_ACQUIRING_CREDENTIALS_REGENERATE,
    payload: data,
})

export const successAcquiringCredentialsRegenerate = data => ({
    type: AcquiringActionTypes.SUCCESS_ACQUIRING_CREDENTIALS_REGENERATE,
    payload: data,
})

export const failureAcquiringCredentialsRegenerate = data => ({
    type: AcquiringActionTypes.FAILURE_ACQUIRING_CREDENTIALS_REGENERATE,
    payload: data,
})

export const finishAcquiringCredentialsRegenerate = data => ({
    type: AcquiringActionTypes.FINISH_ACQUIRING_CREDENTIALS_REGENERATE,
    payload: data,
})

export const startAcquiringChargesDownload = data => ({
    type: AcquiringActionTypes.START_ACQUIRING_CHARGES_DOWNLOAD,
    payload: data,
})

export const successAcquiringChargesDownload = data => ({
    type: AcquiringActionTypes.SUCCESS_ACQUIRING_CHARGES_DOWNLOAD,
    payload: data,
})

export const failureAcquiringChargesDownload = data => ({
    type: AcquiringActionTypes.FAILURE_ACQUIRING_CHARGES_DOWNLOAD,
    payload: data,
})

export const finishAcquiringChargesDownload = data => ({
    type: AcquiringActionTypes.FINISH_ACQUIRING_CHARGES_DOWNLOAD,
    payload: data,
})

export const startSettlementsPdfDownload = data => ({
    type: AcquiringActionTypes.START_SETTLEMENTS_PDF_DOWNLOAD,
    payload: data,
})

export const successSettlementsPdfDownload = data => ({
    type: AcquiringActionTypes.SUCCESS_SETTLEMENTS_PDF_DOWNLOAD,
    payload: data,
})

export const failureSettlementsPdfDownload = data => ({
    type: AcquiringActionTypes.FAILURE_SETTLEMENTS_PDF_DOWNLOAD,
    payload: data,
})

export const finishSettlementsPdfDownload = data => ({
    type: AcquiringActionTypes.FINISH_SETTLEMENTS_PDF_DOWNLOAD,
    payload: data,
})

export const startSettlementPdfDownload = data => ({
    type: AcquiringActionTypes.START_SETTLEMENT_PDF_DOWNLOAD,
    payload: data,
})

export const successSettlementPdfDownload = data => ({
    type: AcquiringActionTypes.SUCCESS_SETTLEMENT_PDF_DOWNLOAD,
    payload: data,
})

export const failureSettlementPdfDownload = data => ({
    type: AcquiringActionTypes.FAILURE_SETTLEMENT_PDF_DOWNLOAD,
    payload: data,
})

export const finishSettlementPdfDownload = data => ({
    type: AcquiringActionTypes.FINISH_SETTLEMENT_PDF_DOWNLOAD,
    payload: data,
})

export const startSettlementsCsvDownload = data => ({
    type: AcquiringActionTypes.START_SETTLEMENTS_CSV_DOWNLOAD,
    payload: data,
})

export const successSettlementsCsvDownload = data => ({
    type: AcquiringActionTypes.SUCCESS_SETTLEMENTS_CSV_DOWNLOAD,
    payload: data,
})

export const failureSettlementsCsvDownload = data => ({
    type: AcquiringActionTypes.FAILURE_SETTLEMENTS_CSV_DOWNLOAD,
    payload: data,
})

export const finishSettlementsCsvDownload = data => ({
    type: AcquiringActionTypes.FINISH_SETTLEMENTS_CSV_DOWNLOAD,
    payload: data,
})

export const startSettlementsPeriodSummaryDownload = data => ({
    type: AcquiringActionTypes.START_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD,
    payload: data,
})

export const successSettlementsPeriodSummaryDownload = data => ({
    type: AcquiringActionTypes.SUCCESS_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD,
    payload: data,
})

export const failureSettlementsPeriodSummaryDownload = data => ({
    type: AcquiringActionTypes.FAILURE_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD,
    payload: data,
})

export const finishSettlementsPeriodSummaryDownload = data => ({
    type: AcquiringActionTypes.FINISH_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD,
    payload: data,
})

export const startChargesReceiptPdf = data => ({
    type: AcquiringActionTypes.START_CHARGES_RECEIPT_PDF,
    payload: data,
})

export const successChargesReceiptPdf = data => ({
    type: AcquiringActionTypes.SUCCESS_CHARGES_RECEIPT_PDF,
    payload: data,
})

export const failureChargesReceiptPdf = data => ({
    type: AcquiringActionTypes.FAILURE_CHARGES_RECEIPT_PDF,
    payload: data,
})

export const finishChargesReceiptPdf = data => ({
    type: AcquiringActionTypes.FINISH_CHARGES_RECEIPT_PDF,
    payload: data,
})

/*************************  Payment Gateway Merchants ************************** */

export const startPaymentGatewayMerchants = data => ({
    type: AcquiringActionTypes.START_PAYMENT_GATEWAY_MERCHANTS,
    payload: data,
})

export const successPaymentGatewayMerchants = data => ({
    type: AcquiringActionTypes.SUCCESS_PAYMENT_GATEWAY_MERCHANTS,
    payload: data,
})

export const finishPaymentGatewayMerchants = data => ({
    type: AcquiringActionTypes.FINISH_PAYMENT_GATEWAY_MERCHANTS,
    payload: data,
})

export const failurePaymentGatewayMerchants = data => ({
    type: AcquiringActionTypes.FAILURE_PAYMENT_GATEWAY_MERCHANTS,
    payload: data,
})
